import React from 'react'
import { PoweredBy } from './poweredBy.view'

export class LogoContainer extends React.Component {
  state = {}

  getImageSrcBySite = (site, isMobileVersion) =>
    require(`../../../common_assets/images/logo-${site}${isMobileVersion
      ? '-mobile'
      : ''}.embedded.svg`)

  getImage = (site, imageSrc, isMobileVersion = false) =>
    imageSrc ? imageSrc : this.getImageSrcBySite(site, isMobileVersion)

  handleLogoMorphLoaded = () => this.setState({ logoMorphLoaded: !!this.props.imageSrc })

  shouldShowPoweredBy = () => this.props.powered_by && !this.state.logoMorphLoaded

  render = () =>
    <a
      href={this.props.href}
      className={`logo ${this.props.alignment}`}
      data-analytics-event-category="Navigation"
      data-analytics-event-action="top logo click"
      data-analytics-event-label={`${this.state.logoMorphLoaded ? 'campaign' : 'regular'}`}
      data-logo-variant-text={this.props.powered_by}
    >
      <img
        alt={this.props.site}
        src={this.getImage(this.props.site, this.props.imageSrc)}
        className={`logo-img logo-img--desktop ${this.state.logoMorphLoaded
          ? 'logo-img--morph'
          : ''}`}
        height="50px"
        onLoad={() => this.handleLogoMorphLoaded()}
      />
      <img
        alt={this.props.site}
        src={this.getImage(this.props.site, this.props.imageSrc, this.props.hasMobileVersion)}
        className={`logo-img logo-img--mobile  ${this.state.logoMorphLoaded
          ? 'logo-img--morph'
          : ''}`}
        height="40px"
        onLoad={() => this.handleLogoMorphLoaded()}
      />
      {this.shouldShowPoweredBy() &&
        <PoweredBy text={this.props.powered_by} site={this.props.site} />}
    </a>
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/header/logo/logo.container.js